/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-07-31 12:08:35
 */
// 用户相关
export const LOGIN = 'LOGIN' // 登录
export const ACCOUNT_LOGIN = 'ACCOUNT_LOGIN' // 登录
export const HBSGSL_LOGIN = 'HBSGSL_LOGIN' // 工商联登录
export const LOGOUT = 'LOGOUT' // 登出
export const SET_USER_INFO = 'SET_USER_INFO' // 设置用户信息
export const SET_TOKEN = 'SET_TOKEN' // 设置用户信息
export const GET_USER_INFO = 'GET_USER_INFO' //获取用户信息

export const SET_IS_ANDROID = 'SET_IS_ANDROID'
export const SET_IS_IOS = 'SET_IS_IOS'
